import React, { useEffect, useRef, useState } from "react";

const Features = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  
  const features = [
    {
      id: 1,
      title: "Worldwide Leader",
      description: "Trusted by over 2 million donors across 50+ countries. The most reliable fundraising platform globally.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/worldwide-leader.png",
      color: "from-blue-600 to-indigo-600",
      lightColor: "from-blue-500 to-indigo-500",
      bgPattern: "bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-100/60 via-transparent to-transparent",
      stat: "2M+",
      statLabel: "donors worldwide",
      benefit: "Global trust"
    },
    {
      id: 2,
      title: "Simple Setup",
      description: "Create your campaign in under 2 minutes. No technical skills, no complicated forms — just your story.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/simple-setup.png",
      color: "from-teal-600 to-emerald-600",
      lightColor: "from-teal-500 to-emerald-500",
      bgPattern: "bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-teal-100/60 via-transparent to-transparent",
      stat: "2 min",
      statLabel: "average setup",
      benefit: "Instant start"
    },
    {
      id: 3,
      title: "4% Platform Fee",
      description: "100% of what you raise goes to your cause. No hidden fees, no fine print, no surprises. Ever.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/zero-fee.png",
      color: "from-emerald-600 to-green-600",
      lightColor: "from-emerald-500 to-green-500",
      bgPattern: "bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-emerald-100/60 via-transparent to-transparent",
      stat: "₹0",
      statLabel: "platform fees",
      benefit: "Keep everything"
    },
    {
      id: 4,
      title: "Share Hope",
      description: "Every campaign is a story of hope. Share yours and watch your community rally around what matters.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/share-hope.png",
      color: "from-amber-600 to-orange-600",
      lightColor: "from-amber-500 to-orange-500",
      bgPattern: "bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-amber-100/60 via-transparent to-transparent",
      stat: "10x",
      statLabel: "viral potential",
      benefit: "Share hope"
    },
    {
      id: 5,
      title: "Easy Social Reach",
      description: "One-click sharing to WhatsApp, Facebook, Twitter, and email. Track who's engaging, in real-time.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/easy-social-reach.png",
      color: "from-purple-600 to-pink-600",
      lightColor: "from-purple-500 to-pink-500",
      bgPattern: "bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-purple-100/60 via-transparent to-transparent",
      stat: "5",
      statLabel: "social platforms",
      benefit: "One-click share"
    },
    {
      id: 6,
      title: "24/7 Customer Service",
      description: "Real humans, real empathy. Our support team is here for you — day or night, rain or shine.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/customer-service.png",
      color: "from-rose-600 to-red-600",
      lightColor: "from-rose-500 to-red-500",
      bgPattern: "bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-rose-100/60 via-transparent to-transparent",
      stat: "<2 min",
      statLabel: "response time",
      benefit: "24/7 support"
    },
  ];

  // Auto-rotate feature spotlight
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % features.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative bg-gradient-to-b from-gray-50 to-white py-10 overflow-hidden">
      
      {/* Dynamic background that changes with active feature */}
      <div className="absolute inset-0 transition-all duration-1000">
        {features.map((feature, index) => (
          <div
            key={feature.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === activeIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-5`}></div>
            <div className={`absolute top-0 -left-40 w-[800px] h-[800px] ${feature.bgPattern} blur-3xl`}></div>
            <div className={`absolute bottom-0 -right-40 w-[800px] h-[800px] ${feature.bgPattern} blur-3xl`}></div>
          </div>
        ))}
      </div>

      {/* Subtle noise texture */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        backgroundSize: '120px 120px'
      }}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-0">
        
        {/* Section Header - ORIGINAL SIZES, REDUCED BOTTOM MARGIN */}
        <div className="text-center max-w-4xl mx-auto mb-16 md:mb-20">
          
          {/* Trust badge - ORIGINAL SIZE */}
          <div className="inline-flex items-center gap-3 px-5 py-2.5 bg-white rounded-full shadow-lg shadow-gray-200/50 mb-6">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-60"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-teal-600"></span>
            </span>
            <span className="text-sm font-semibold text-gray-700">
              Why thousands choose DonatePe
            </span>
          </div>
          
          {/* Headline - ORIGINAL SIZE */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 tracking-tight mb-6">
            Fundraising done{' '}
            <span className="relative inline-block">
              <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">
                differently
              </span>
              <span className="absolute -bottom-3 left-0 w-full h-3 bg-gradient-to-r from-teal-200/40 to-emerald-200/40 blur-md"></span>
              <span className="absolute -bottom-3 left-0 w-full h-1 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-full"></span>
            </span>
          </h2>
          
          {/* Subheadline - ORIGINAL SIZE */}
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            No fees. No fine print. Just pure impact, from your first donation to your last.
          </p>
        </div>

        {/* Hero Feature Spotlight - ORIGINAL SIZES, REDUCED BOTTOM MARGIN */}
        <div className="relative mb-20 lg:mb-24">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            
            {/* Left side - ORIGINAL SIZES */}
            <div className="space-y-8">
              
              {/* Feature title - ORIGINAL SIZE */}
              <h3 className={`text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r ${features[activeIndex].color} bg-clip-text text-transparent transition-all duration-500`}>
                {features[activeIndex].title}
              </h3>

              {/* Feature description - ORIGINAL SIZE */}
              <p className="text-lg text-gray-600 leading-relaxed">
                {features[activeIndex].description}
              </p>

              {/* Stats block - ORIGINAL SIZE */}
              <div className="flex items-center gap-8 pt-4">
                <div className="text-left">
                  <div className={`text-4xl md:text-5xl font-bold bg-gradient-to-r ${features[activeIndex].color} bg-clip-text text-transparent`}>
                    {features[activeIndex].stat}
                  </div>
                  <div className="text-sm text-gray-500 mt-1">
                    {features[activeIndex].statLabel}
                  </div>
                </div>
                <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-300 to-transparent"></div>
                <div className="text-left">
                  <div className="text-2xl font-semibold text-gray-700">
                    {features[activeIndex].benefit}
                  </div>
                  
                </div>
              </div>

              {/* CTA - ORIGINAL SIZE */}
              <button className="mt-6 px-8 py-4 bg-gray-900 text-white rounded-xl font-semibold hover:bg-gray-800 transition-colors shadow-xl flex items-center gap-3 group">
                <span>Start your fundraiser</span>
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>

            {/* Right side - ORIGINAL SIZES */}
            <div className="relative flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md">
                
                {/* Animated gradient background - ORIGINAL SIZE */}
                <div className={`absolute inset-0 bg-gradient-to-r ${features[activeIndex].color} rounded-[40px] blur-3xl opacity-20 animate-pulse-slow`}></div>
                
                {/* Main visual - ORIGINAL SIZE */}
                <div className="relative bg-white rounded-3xl shadow-2xl p-8 border border-gray-100">
                  
                  {/* Icon with colored background - ORIGINAL SIZE */}
                  <div className={`relative w-32 h-32 mx-auto mb-6 bg-gradient-to-br ${features[activeIndex].color} rounded-2xl shadow-2xl flex items-center justify-center transform rotate-3 hover:rotate-0 transition-transform duration-500`}>
                    <div className="absolute inset-0 bg-white rounded-2xl opacity-0"></div>
                    <img
                      src={features[activeIndex].icon}
                      alt={features[activeIndex].title}
                      className="relative w-20 h-20 object-contain brightness-0 invert filter"
                    />
                  </div>
                  
                  {/* Feature highlight - ORIGINAL SIZE */}
                  <div className="text-center">
                    <h4 className="text-2xl font-bold text-gray-900 mb-2">
                      {features[activeIndex].title}
                    </h4>
                    <p className="text-gray-500">
                      {features[activeIndex].description.substring(0, 60)}...
                    </p>
                  </div>
                  
                  {/* Decorative elements - ORIGINAL SIZE */}
                  <div className="flex justify-center gap-2 mt-6">
                    {[...Array(5)].map((_, i) => (
                      <div
                        key={i}
                        className={`w-2 h-2 rounded-full bg-gradient-to-r ${features[activeIndex].color} opacity-${20 + i * 15}`}
                      ></div>
                    ))}
                  </div>
                </div>
                
                {/* MOVED: Feature indicator - Dots below the card */}
                <div className="flex items-center justify-center gap-4 mt-6">
                  <div className="flex gap-1.5">
                    {features.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setActiveIndex(idx)}
                        className={`transition-all duration-500 rounded-full ${
                          idx === activeIndex
                            ? `w-10 h-2 bg-gradient-to-r ${features[idx].color}`
                            : 'w-2 h-2 bg-gray-300 hover:bg-gray-400'
                        }`}
                      />
                    ))}
                  </div>
                  <span className="text-sm text-gray-400 font-medium">
                    {activeIndex + 1} / {features.length}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Grid - ORIGINAL SIZES */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <button
              key={feature.id}
              onClick={() => setActiveIndex(index)}
              className={`group relative p-4 transition-all duration-300 ${
                index === activeIndex ? 'scale-105' : 'opacity-60 hover:opacity-100'
              }`}
            >
              <div className="flex flex-col items-center text-center">
                
                {/* Small colored icon - ORIGINAL SIZE */}
                <div className={`relative w-12 h-12 mb-3 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-6 h-6 object-contain brightness-0 invert filter"
                  />
                  
                  {/* Active indicator - ORIGINAL SIZE */}
                  {index === activeIndex && (
                    <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white animate-pulse"></div>
                  )}
                </div>
                
                {/* Feature title - ORIGINAL SIZE */}
                <h5 className="text-xs font-semibold text-gray-700 mb-1">
                  {feature.title}
                </h5>
                
                {/* Tiny progress bar - ORIGINAL SIZE */}
                <div className="w-full h-0.5 bg-gray-100 rounded-full overflow-hidden mt-1">
                  <div
                    className={`h-full bg-gradient-to-r ${feature.color} transition-all duration-500`}
                    style={{ width: index === activeIndex ? '100%' : '0%' }}
                  ></div>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Trust bar - ORIGINAL SIZES, REDUCED TOP MARGIN */}
        <div className="mt-16 md:mt-20 text-center">
          <div className="inline-flex flex-col items-center gap-8">
            
            {/* Stats - ORIGINAL SIZE */}
            <div className="flex items-center gap-12">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-1">3L</div>
                <p className="text-sm text-gray-500">Donors</p>
              </div>
              <div className="w-px h-10 bg-gray-200"></div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-1">100%</div>
                <p className="text-sm text-gray-500">impact</p>
              </div>
              <div className="w-px h-10 bg-gray-200"></div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-1">4%</div>
                <p className="text-sm text-gray-500">Fees(On Self Crowdfunding )</p>
              </div>
            </div>
            
            {/* Trust message - ORIGINAL SIZE */}
            <p className="text-sm text-gray-400 flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-teal-500 rounded-full animate-pulse"></span>
              <span className="italic"></span>
              <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></span>
            </p>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.2; transform: scale(1); }
          50% { opacity: 0.3; transform: scale(1.05); }
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
        .brightness-0 {
          filter: brightness(0);
        }
        .invert {
          filter: invert(1);
        }
      `}</style>
    </section>
    
  );
};

export default Features;